import { render, staticRenderFns } from "./CrudTable.vue?vue&type=template&id=a2b1fc46"
import script from "./CrudTable.vue?vue&type=script&lang=ts"
export * from "./CrudTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports